export const Images = {
    Logo: require('./images/Logo.png'),
    User: require('./images/user.png'),
}
